import { useMemo, useState } from 'react';
import { FeatureSet } from '~shared/types/pricing/features';
import { FeatureSetMap } from '~pricing/transformers/types';
import { convertFeatureSetToMap } from '~pricing/lib/lib-helpers';

export default function usePackageFeatureSet(featureSet: FeatureSet): FeatureSetMap {
  const [featureSetMap, setFeatureSetMap] = useState<FeatureSetMap>({});
  useMemo(() => {
    setFeatureSetMap(convertFeatureSetToMap(featureSet));
  }, [featureSet]);

  return featureSetMap;
}
